import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Freezer from '@src/components/Freezer';
import IconCloseL from '@src/components/Icon/set/IconCloseL';

import css from './style.module.scss';

const MapLayer = (props) => {
	const { Map, fixed, adaptive, sliderKey, onClose, MapSliderRC } = props;
	return (
		<div
			className={cn(css.block, {
				[css.block_fixed]: fixed,
				[css[`block_adapt_${adaptive}`]]: !!adaptive,
			})}
		>
			<Freezer />
			{onClose && (
				<a
					className={css.close}
					onClick={onClose}
					tabIndex={0}
					role="link"
				>
					<span className={css.closeBtn}>
						<IconCloseL className={css.closeIcon} />
					</span>
				</a>
			)}
			{Map && (
				<div className={css.map}>
					<Map btnsMix={css.btnsMix} />
				</div>
			)}
			{MapSliderRC && (
				<div className={css.slider}>
					<MapSliderRC key={sliderKey} slideMix={css.slide} />
				</div>
			)}
		</div>
	);
};

MapLayer.propTypes = {
	sliderKey: PropTypes.string,
	adaptive: PropTypes.oneOf(['default']),
	Map: PropTypes.elementType,
	fixed: PropTypes.bool,
	onClose: PropTypes.func,
	MapSliderRC: PropTypes.elementType,
};

MapLayer.defaultProps = {
	sliderKey: undefined,
	adaptive: undefined,
	Map: undefined,
	fixed: true,
	onClose: undefined,
	MapSliderRC: undefined,
};

export default MapLayer;
